<div class="card">
  <div class="rounded border border-surface-200 dark:border-surface-700 p-6 bg-surface-0 dark:bg-surface-900">
    <div class="img">
      <p-skeleton width="100%" height="14rem" />
      <div class="title">
        <p-skeleton width="10rem" height="2rem" />
        <p-skeleton width="5rem" height="2rem" />
      </div>
      <div class="desc">
        <p-skeleton width="20rem" height="3rem" />
      </div>
      <div class="footer">
        <div class="asso">
          <p-skeleton shape="circle" size="2rem" styleClass="mr-2" />
          <p-skeleton width="4rem" height="2rem" />
        </div>

        <div class="loc-date-heart">
          <p-skeleton width="5rem" height="2rem" />
          <p-skeleton width="5rem" height="2rem" />
          <p-skeleton shape="circle" size="2rem" />
        </div>
      </div>
    </div>
  </div>
</div>
